import { request as getNyxGames, error as onNyxGamesError, finish as onNyxGamesFinish } from './reducers/get-nyx-games';

import {
    request as getLiveGames,
    error as onLiveGamesError,
    finish as onliveGamesFinish,
} from './reducers/get-live-games';

import {
    request as getLiveGamesCategories,
    error as onLiveGamesCategoriesError,
    finish as onliveGamesCategoriesFinish,
} from './reducers/get-live-games-categories';

import {
    request as updateLiveGamesCategories,
    error as onUpdateLiveGamesCategoriesError,
    finish as onUpdateliveGamesCategoriesFinish,
} from './reducers/update-live-game-categories';

import {
    request as addLiveGames,
    error as onAddLiveGamesError,
    finish as onAddliveGamesFinish,
} from './reducers/add-new-live-game';

import { request as editLiveGames, finish as onEditliveGamesFinish } from './reducers/edit-live-game';

import {
    request as getLiveGamesById,
    error as ongetLiveGamesByIdError,
    finish as ongetLiveGamesByIdFinish,
} from './reducers/get-live-game-by-id';

import {
    request as imageUpload,
    error as imageUploadError,
    finish as imageUploadFinish,
} from './reducers/image-upload';

import {
    request as editLiveGamesOrder,
    error as editLiveGamesOrderError,
    finish as editLiveGamesOrderFinish,
} from './reducers/edit-live-games-order';

import {
    request as editLiveCategoriesOrder,
    error as editLiveCategoriesOrderError,
    finish as editLiveCategoriesOrderFinish,
} from './reducers/update-live-games-categories-order';

import {
    request as deleteLiveGame,
    error as deleteLiveGameError,
    finish as deleteLiveGameFinish,
    clear as clearDeleteLiveGameState,
} from './reducers/delete-live-game';

import {
    request as addLiveGamesCategory,
    error as onAddLiveGamesCategoryError,
    finish as onAddliveGamesCategoryFinish,
} from './reducers/add-new-category';

import * as providerGames from './reducers/get-provider-games';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    GET_PROVIDER_GAMES_REQUEST: providerGames.request,
    GET_PROVIDER_GAMES_ERROR: providerGames.error,
    GET_PROVIDER_GAMES_FINISH: providerGames.finish,

    NYX_GAMES_GET_REQUEST: getNyxGames,
    NYX_GAMES_GET_ERROR: onNyxGamesError,
    NYX_GAMES_GET_FINISH: onNyxGamesFinish,
    LIVE_GAMES_GET_REQUEST: getLiveGames,
    LIVE_GAMES_GET_ERROR: onLiveGamesError,
    LIVE_GAMES_GET_FINISH: onliveGamesFinish,
    LIVE_GAMES_CATEGORIES_GET_REQUEST: getLiveGamesCategories,
    LIVE_GAMES_CATEGORIES_GET_ERROR: onLiveGamesCategoriesError,
    LIVE_GAMES_CATEGORIES_GET_FINISH: onliveGamesCategoriesFinish,
    LIVE_GAMES_CATEGORIES_UPDATE_REQUEST: updateLiveGamesCategories,
    LIVE_GAMES_CATEGORIES_UPDATE_ERROR: onUpdateLiveGamesCategoriesError,
    LIVE_GAMES_CATEGORIES_UPDATE_FINISH: onUpdateliveGamesCategoriesFinish,
    LIVE_GAMES_POST_REQUEST: addLiveGames,
    LIVE_GAMES_POST_ERROR: onAddLiveGamesError,
    LIVE_GAMES_POST_FINISH: onAddliveGamesFinish,
    LIVE_GAME_BY_ID_GET_REQUEST: getLiveGamesById,
    LIVE_GAME_BY_ID_GET_ERROR: ongetLiveGamesByIdError,
    LIVE_GAME_BY_ID_GET_FINISH: ongetLiveGamesByIdFinish,
    LIVE_GAMES_PUT_REQUEST: editLiveGames,
    LIVE_GAMES_PUT_ERROR: ongetLiveGamesByIdError,
    LIVE_GAMES_PUT_FINISH: onEditliveGamesFinish,
    IMAGE_UPLOAD_REQUEST: imageUpload,
    IMAGE_UPLOAD_ERROR: imageUploadError,
    IMAGE_UPLOAD_FINISH: imageUploadFinish,
    LIVE_GAMES_EDIT_ORDER_REQUEST: editLiveGamesOrder,
    LIVE_GAMES_EDIT_ORDER_ERROR: editLiveGamesOrderError,
    LIVE_GAMES_EDIT_ORDER_FINISH: editLiveGamesOrderFinish,
    LIVE_GAME_DELETE_REQUEST: deleteLiveGame,
    LIVE_GAME_DELETE_ERROR: deleteLiveGameError,
    LIVE_GAME_DELETE_FINISH: deleteLiveGameFinish,
    CLEAR_LIVE_GAME_DELETE_STATE: clearDeleteLiveGameState,
    LIVE_CATEGORIES_EDIT_ORDER_REQUEST: editLiveCategoriesOrder,
    LIVE_CATEGORIES_EDIT_ORDER_ERROR: editLiveCategoriesOrderError,
    LIVE_CATEGORIES_EDIT_ORDER_FINISH: editLiveCategoriesOrderFinish,
    LIVE_GAMES_CATEGORIES_ADD_REQUEST: addLiveGamesCategory,
    LIVE_GAMES_CATEGORIES_ADD_ERROR: onAddLiveGamesCategoryError,
    LIVE_GAMES_CATEGORIES_ADD_FINISH: onAddliveGamesCategoryFinish,
});
